import module from 'guest/module.js'
import template from './template.html'

const catalogos = {
  Status: {
    '0': 'guest.support.list.request.status.0',
    '1': 'guest.support.list.request.status.1',
    '2': 'guest.support.list.request.status.2',
  },
}

class GuestSoporteComponent {
  constructor ($notify, $dialog, $state) {
    this.$notify = $notify
    this.$dialog = $dialog
    this.$state = $state
    this.soporte = null
    this.filters = {
      status: '2',
      needle: '',
    }
    this.catalogos = catalogos
  }

  $onInit () {
    this.data = this.soporte.$select(null, '-date')
      .map((item) => {
        item.selected = false
        item.response = ''
        return item
      })
  }

  add () {
    this.$dialog.show('guest.support.add', {data: this.soporte})
      .then(() => (this.$state.reload()))
  }

  $response (item) {
    item.saving = true
    item.$response(item.response)
      .then(() => {
        item.response = ''
        item.selected = false
      })
      .catch((error) => (this.$notify.error(error)))
      .finally(() => (item.saving = false))
  }

  $setStatus (item, status) {
    item.saving = true
    item.$setStatus(status)
      .finally(() => (item.saving = false))
  }
}

module.component('guestSoporte', {
  controller: GuestSoporteComponent,
  template,
  bindings: {
    soporte: '<',
  },
})



// WEBPACK FOOTER //
// ./src/guest/components/soporte/component.js